module.exports = __webpack_public_path__ + "media/vid-slide-2.e53b113a.mp4";